import React from 'react';
import './Backgrounds.css';

function BgPic2() {

    return (
        <div className="bg2-container">

        </div>
    );
}

export default BgPic2;